import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { appConfig } from 'cd-eft/config/AppConfig';
import './SurveyListDataGrid.scss';
import { Modal, ModalBody, ModalHeader, ModalFooter, Container } from 'reactstrap';

// Components
import { SurveySummary } from '../SurveySummary';
import { SurveyPointsDataGrid } from '../SurveyPointsDataGrid/SurveyPointsDataGrid';
import { PointTranslation } from '../PointTranslation';
import { CollapseMenu } from '../../common/CollapseMenu/CollapseMenu';


// Common
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import stores from 'cd-eft/models/Stores';
import { SOSurveys } from '../SOSurveys';
import { DemIntegration } from 'cd-eft/components/common/DemIntegration/DemIntegration';


const setStore = stores.AppStore.surveyEngineeringStore;
const designStore = stores.AppStore.designStore;
interface ISurveyListDataGridComponentProps {
  surveyDesignForceOpen: boolean;
  designREF: any;
  startWatchHandler: any;
  stopWatchHandler: any;
  updateSnapIcon: any;
  toggleSnapping: any;
}

const SurveyListDataGridComponent = (props: ISurveyListDataGridComponentProps) => {
  designStore.designElementTypeId = appConfig.hardCodes.designElementTypeSuface //To enable ToolBar on the map for Surface
  const [state,setStateInfo]= useState({
    headerTitle:"",
    onClickInformation:false
  });
  const onClickInformationToggle = (title:string) => {
    setStateInfo(prevState => ({
      headerTitle:title, onClickInformation:!prevState.onClickInformation
    }));
  }
  return (
    <>
      {setStore.isLoading && !designStore.isLoading && <Loader />}
            {/* informational button */}
            {state.onClickInformation ? (
              <div>
                <Modal
                  isOpen={state.onClickInformation}
                  toggle={()=>onClickInformationToggle(state.headerTitle)}
                  centered={true}
                  className="eft-action-modal"
                  aria-label={state.headerTitle}
                >
                  <ModalHeader toggle={() => onClickInformationToggle(state.headerTitle)}  className='header-info-detail'>
                    <div className="display-flex flex-align-center">
                      <strong>{`Information Details on ${state.headerTitle}`}</strong> 
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <Container>
                     <ProfileDetails/>
                    </Container>
                  </ModalBody>
                  <ModalFooter>
                    <button className="usa-button usa-button--outline" onClick={()=>onClickInformationToggle(state.headerTitle)}>
                      Close
                    </button>
                  </ModalFooter>
                </Modal>
              </div>
      ) : null}

      <CollapseMenu
        title={`Surface Design`}
        showAsHeader={true}
        cardBodyId={`survey-container`}
        noIcon={true}
        forceOpen={props.surveyDesignForceOpen}
        isOpen={true}
        className="designelement-container"
        titleClass="collapse-title-span"
        sectionHelp={true}
        sectionHelpCallback={()=>onClickInformationToggle("Surface Design")}
      >

        {/* tabs */}
        <div className="rcn-top-nav">
          <ul>
            <SingleTab tabName="Survey Summary" visualTitle="Summary" testid="surveysummarytab" />
            {!setStore.currentSurvey.surveyId && setStore.currentSurvey.surveyName && (
              <SingleTab tabName="New Survey" visualTitle={setStore.currentSurvey.surveyName} testid="newsurveytab" />
            )}
            {setStore.currentDEM?.demId && (<SingleTab tabName="New DEM" visualTitle="Define AOI and DEM" testid="newdemtab" />)}
            {setStore.currentSurvey.surveyId && (
              <SingleTab
                tabName="Edit Survey"
                visualTitle={
                  setStore.currentSubTab === 'survey'
                    ? setStore.currentSurvey.surveyName
                    : setStore.stationOffsetObject.alignmentName
                }
                testid="editsurveytab"
              />
            )}
            {!setStore.currentSurvey.surveyId && setStore.isHeaderAccepted && (
              <SingleTab tabName="Point Translation" visualTitle="Point Translation" testid="pointtranslationtab" />
            )}
            {/* {!setStore.currentDem.demId && setStore.currentDem.demName && (
              <SingleTab tabName="New DEM" visualTitle={setStore.currentDEM.demName} testid="newdemtab" />
            )} */}
          </ul>
        </div>

        {/* content */}
        {setStore.currentTab === 'Survey Summary' && <SurveySummary designREF={props.designREF} startWatchHandler={props.startWatchHandler} updateSnapIcon = {props.updateSnapIcon} toggleSnapping = {props.toggleSnapping} />}
        {(setStore.currentTab === 'New Survey' || setStore.currentTab === 'Edit Survey') &&
          setStore.currentSurvey.surveyType === appConfig.hardCodes.surveyTypeXYZ && <SurveyPointsDataGrid startWatchHandler={props.startWatchHandler} stopWatchHandler={props.stopWatchHandler} />}
        {(setStore.currentTab === 'New Survey' || setStore.currentTab === 'Edit Survey') &&
          setStore.currentSurvey.surveyType !== appConfig.hardCodes.surveyTypeXYZ && <SOSurveys />}
        {setStore.currentTab === 'Point Translation' && <PointTranslation />}
        {setStore.currentTab === 'New DEM' && <DemIntegration mapView={props.designREF.view} project_class_id={1} demProjectVM={props.designREF} />}

      </CollapseMenu>
    </>
  );
};

export const SurveyListDataGrid = observer(SurveyListDataGridComponent);

interface ISingleTabProps {
  tabName: string;
  visualTitle: string;
  testid: string;
}

const SingleTab = (props: ISingleTabProps) => {
  const { tabName, testid, visualTitle } = props;
  return (
    <li className="table-name">
      <a
        data-testid={testid}
        className={setStore.currentTab === tabName ? 'active' : ''}
        onClick={() => setStore.changeTab(tabName)}
      >
        <strong>{visualTitle}</strong>
      </a>
    </li>
  );
};

export const ProfileDetails = (props: { className?: string }) => {
  return (
      <div className={props.className ? props.className : ''} tabIndex={0}>
          <p>
            NETS utilizes only one surface at a time.
            The use of a DEM surface or a Survey are mutually exclusive.
            The first surface must be deleted to use a different surface.  
            If alignments or other features have been created on the original surface, 
            they will be maintained to the extent possible.
          </p>
      </div>
  );
};